import type {
  GoodsUnitState,
  Pagination,
  UnitsFilters,
} from '@app/pages/Warehouses/GoodsUnits/types';

export const PF = 'goods-units';

export const stateTitles: Record<GoodsUnitState, string> = {
  Available: 'Доступен',
  Sold: 'Продан',
  WrittenOff: 'Списан',
  InProgress: 'В работе',
  Blocked: 'Заблокирован',
};

export const initialFilters: UnitsFilters = {
  DateS: null,
  DateE: null,
  WarehouseIds: [],
  ProductIds: [],
  StateIds: [],
};

export const initPagination: Pagination = {
  ItemsPerPage: 20,
  PageN: 1,
  Total: 0,
};
